module.exports = __webpack_public_path__ + "img/icon-special.8643a8d6.svg";